import { AssignmentInd, DirectionsRun, HourglassEmpty, Cancel, Error, CheckCircle } from "@mui/icons-material";
import { alpha, Chip, SvgIconProps } from "@mui/material";
import { blue, orange, red, green, grey } from "@mui/material/colors";
import { chipOpacity, chipPadding } from "./common";
import { PaymentTaskState } from "../../../enums/tasks";
import ReplayIcon from '@mui/icons-material/Replay';

export const getPaymentTaskStateColor = (state: PaymentTaskState): string => {
    switch (state) {
        case PaymentTaskState.SCHEDULED:
            return alpha(blue[500], chipOpacity);
        case PaymentTaskState.OUT_FOR_PAYMENT:
            return alpha(orange[500], chipOpacity);
        case PaymentTaskState.IN_PROGRESS:
            return alpha(orange[700], chipOpacity);
        case PaymentTaskState.COMPLETED:
            return alpha(green[500], chipOpacity);
        case PaymentTaskState.AWAITING_RETURN:
            return alpha(red[700], chipOpacity);
        case PaymentTaskState.CANCELLED:
            return alpha(grey[700], chipOpacity);
        case PaymentTaskState.FAILED:
            return alpha(red[500], chipOpacity);
        default:
            return alpha(grey[500], chipOpacity);
    }
};

export const getPaymentTaskStateIcon = (state: PaymentTaskState): JSX.Element => {
    const iconProps: SvgIconProps = { fontSize: "small", color: "inherit" };

    switch (state) {
        case PaymentTaskState.SCHEDULED:
            return <AssignmentInd {...iconProps} />;
        case PaymentTaskState.OUT_FOR_PAYMENT:
            return <DirectionsRun {...iconProps} />;
        case PaymentTaskState.IN_PROGRESS:
            return <HourglassEmpty {...iconProps} />;
        case PaymentTaskState.COMPLETED:
            return <CheckCircle {...iconProps} />;
        case PaymentTaskState.AWAITING_RETURN:
            return <ReplayIcon {...iconProps} />;
        case PaymentTaskState.CANCELLED:
            return <Cancel {...iconProps} />;
        case PaymentTaskState.FAILED:
            return <Error {...iconProps} />;
    }
};

export const showPaymentTaskState = (state: PaymentTaskState): JSX.Element => {
    return (
        <Chip
            icon={getPaymentTaskStateIcon(state)}
            label={<b>{state.toString().replaceAll("_", " ")}</b>}
            variant="filled"
            style={{
                margin: 4,
                padding: chipPadding,
                backgroundColor: getPaymentTaskStateColor(state),
            }}
        />
    );
};